const ImagePlaceholder = () => {
  return (
    <div className="animate-pulse space-x-4" style={{ height: 336, width: 224 }}>
      <div className="bg-slate-400 h-full w-full rounded-lg"></div>
    </div>
  );
};

export default ImagePlaceholder;